// Data
import revutopics from "~/data/revutopics.json";

// Deps
import { selectStyles } from "~/styleguide/forms";
import { createComponent } from "react-fela";

// Components
import MultiSelect from "~/components/shared/form/multi-select";

// Grab types with more than one published resource
const options = revutopics
    .map(revutopic => {
        return { value: revutopic.id, label: revutopic.name, count: revutopic.count };
    })
    .filter(({ count }) => count && count > 0);

export default function RevuTopicsFilter({ handleRevuTopicsChange, selected }) {
    // Can't filter by types if there are none
    if (!revutopics || !revutopics.length) return null;

    return (
        <Container>
            <p style={{ fontSize: "14px", marginBottom: "12px" }}>
                Topics
            </p>

            <MultiSelect
                options={options}
                onChange={handleRevuTopicsChange}
                selected={selected}
                type="Types"
            />
        </Container>
    );
}

const Container = createComponent(() => ({
    ...selectStyles
}));
